function SpinnerFullPage() {
  return (
    <div className="spinnerFullpage">
      <div className="spinnerContainer">
        <div className="spinner"></div>
      </div>
    </div>
  );
}

export default SpinnerFullPage;
